export default "__VITE_ASSET__DA4Egtz0__"